import { render, staticRenderFns } from "./KeyTwentyOne.vue?vue&type=template&id=1028b09e&scoped=true&"
import script from "./KeyTwentyOne.vue?vue&type=script&lang=js&"
export * from "./KeyTwentyOne.vue?vue&type=script&lang=js&"
import style0 from "./KeyTwentyOne.vue?vue&type=style&index=0&id=1028b09e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1028b09e",
  null
  
)

export default component.exports